// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3ZM4h","savePackageButton":"ClientWallet_savePackageButton__C_4UF"};